import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × FRAGONARD PARFUMEUR: Traditional perfumery visualized as color diffusion
// Color plumes, diffusion fields, glass geometry
export function VasarelyFragonardMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <radialGradient id="fragonard-plume1">
          <stop offset="0%" stopColor="#E6B0AA" stopOpacity="0.6" />
          <stop offset="50%" stopColor="#D7BDE2" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#AED6F1" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="fragonard-plume2">
          <stop offset="0%" stopColor="#F9E79F" stopOpacity="0.6" />
          <stop offset="50%" stopColor="#FAD7A0" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#F5CBA7" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="fragonard-plume3">
          <stop offset="0%" stopColor="#A9DFBF" stopOpacity="0.6" />
          <stop offset="50%" stopColor="#85C1E2" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#BB8FCE" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="fragonard-glass" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.8" />
          <stop offset="50%" stopColor="#F0F0F0" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#E0E0E0" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      {/* Light cream background */}
      <rect x="0" y="0" width="794" height="1123" fill="#FAF8F5" />

      <g transform="translate(397 540)">
        {/* Diffusion fields */}
        {[
          { cx: -150, cy: -200, r: 180, grad: "fragonard-plume1" },
          { cx: 120, cy: -150, r: 200, grad: "fragonard-plume2" },
          { cx: -100, cy: 100, r: 190, grad: "fragonard-plume3" },
          { cx: 130, cy: 120, r: 170, grad: "fragonard-plume1" },
          { cx: 0, cy: -50, r: 160, grad: "fragonard-plume2" },
        ].map((plume, i) => (
          <circle
            key={i}
            cx={plume.cx}
            cy={plume.cy}
            r={plume.r}
            fill={`url(#${plume.grad})`}
          />
        ))}

        {/* Color plumes (scent in motion) */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          const length = 200 + Math.sin(i * 0.5) * 50;
          const colors = ["#E6B0AA", "#F9E79F", "#A9DFBF", "#D7BDE2"];
          
          return (
            <path
              key={i}
              d={`M 0,0 Q ${Math.cos(angle) * length * 0.5},${Math.sin(angle) * length * 0.5} ${Math.cos(angle) * length},${Math.sin(angle) * length}`}
              fill="none"
              stroke={colors[i % 4]}
              strokeWidth="2"
              opacity="0.15"
            />
          );
        })}

        {/* Glass geometry */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 14 }).map((_, j) => {
            const x = (i - 4.5) * 70;
            const y = (j - 6.5) * 70;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 30}
                y={y - 30}
                width="60"
                height="60"
                fill="url(#fragonard-glass)"
                stroke="#D0C8C0"
                strokeWidth="1"
                opacity="0.2"
              />
            );
          })
        )}

        {/* Perfume bottle outline */}
        <g transform="translate(0 0)">
          {/* Bottle body */}
          <rect
            x="-50"
            y="-80"
            width="100"
            height="140"
            rx="10"
            fill="url(#fragonard-glass)"
            stroke="#C8B8A8"
            strokeWidth="2"
            opacity="0.5"
          />
          
          {/* Bottle neck */}
          <rect
            x="-20"
            y="-100"
            width="40"
            height="20"
            fill="url(#fragonard-glass)"
            stroke="#C8B8A8"
            strokeWidth="2"
            opacity="0.5"
          />
          
          {/* Cap */}
          <rect
            x="-25"
            y="-120"
            width="50"
            height="20"
            rx="5"
            fill="#C8B8A8"
            opacity="0.4"
          />

          {/* Glass reflections */}
          <rect
            x="-40"
            y="-70"
            width="10"
            height="100"
            fill="#FFFFFF"
            opacity="0.3"
          />
          
          {/* Perfume liquid level */}
          <rect
            x="-45"
            y="20"
            width="90"
            height="35"
            rx="8"
            fill="#E6B0AA"
            opacity="0.3"
          />
        </g>

        {/* Scent diffusion circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 70 + i * 25;
          const colors = ["#E6B0AA", "#F9E79F", "#A9DFBF", "#D7BDE2"];
          
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={colors[i % 4]}
              strokeWidth="1"
              opacity={0.25 - i * 0.018}
            />
          );
        })}
      </g>

      {/* Scent in motion */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="10" fill="#C8B8A8" fontStyle="italic" letterSpacing="2">
        parfum en mouvement
      </text>
    </g>
  );
}
